import { MutationActions, QueryKeys, useEntityMutation } from "@/api/core";
import { useTimelineContext } from "@/contexts/timeline-context";
import { useApi } from "@/hooks";
import { type Group, groupRelationshipSchema, groupSchema } from "@/schemas";
import {
  findEntityById,
  removePageItem,
  updateQueryData,
} from "@/utils/queries";

interface Variables {
  id: string;
}

function useLeaveGroup() {
  const api = useApi();
  const { pinnedGroup, setPinnedGroup } = useTimelineContext();

  return useEntityMutation({
    globalQueryKey: QueryKeys.groupRelationships.global,
    action: MutationActions.UPDATE,
    schema: groupRelationshipSchema,
    mutationFn: (variables: Variables) =>
      api.post(`/api/v1/groups/${variables.id}/leave`),
    onSuccess(_response, variables) {
      const group = findEntityById(
        QueryKeys.groups.global,
        variables.id,
      ) as Group;

      updateQueryData(
        QueryKeys.groups.global,
        { ...group, members_count: group.members_count - 1 },
        groupSchema,
      );
      removePageItem(
        QueryKeys.groups.search(),
        variables.id,
        (o: any, n: any) => o.id === n,
      );

      if (pinnedGroup?.group_id === variables.id) {
        setPinnedGroup(null);
      }
    },
  });
}

export { useLeaveGroup };
